import ArrowRightIcon from '@raison/static/icons/arrow-right-s-line.svg';
import {InlineSvg, styles} from '@raison/ui-kit';
import React from 'react';
import {Link} from 'react-router';

export function NavigationList({children}: NavigationList.Props) {
    return <ul className='flex list-none flex-col'>{children}</ul>;
}

function NavigationListItem(item: NavigationList.Item) {
    const renderInner = (item: NavigationList.Item) => (
        <>
            <div className={'flex size-9 items-center justify-center rounded-full bg-shade-20'}>
                <InlineSvg src={item.icon} className={'size-5 text-neutral-90'} />
            </div>
            <div className={'flex-1'}>{item.label}</div>
            <InlineSvg src={ArrowRightIcon} className={'size-5 text-neutral-90'} />
        </>
    );

    return (
        <li key={item.label}>
            {item.path ? (
                <Link to={item.path} onClick={item.action} className={cls.item}>
                    {renderInner(item)}
                </Link>
            ) : (
                <button onClick={item.action} className={cls.item}>
                    {renderInner(item)}
                </button>
            )}
        </li>
    );
}

export namespace NavigationList {
    export type Props = {
        children: React.ReactNode;
    };
    export type Item = {
        label: string;
        icon: string;
        path?: string;
        action?: () => void;
    };
}

NavigationList.Item = NavigationListItem;

const cls = styles({
    item: 'fv-text-xl-regular flex w-full cursor-pointer items-center gap-4 p-4 text-left text-neutral-100',
});
